var map = {
	"./cards/tier/a.svg": "a4a1",
	"./cards/tier/b.svg": "284b",
	"./cards/tier/c.svg": "195e",
	"./cards/tier/d.svg": "a08f",
	"./cards/tier/e.svg": "78f7c",
	"./cards/tier/f.svg": "e708",
	"./cards/tier/s.svg": "9a4f",
	"./cards/tier/u.svg": "8fb3",
	"./cards/tier/x.svg": "a081",
	"./icons/search.svg": "d878",
	"./icons/search2.svg": "caff",
	"./logo/spirespy.svg": "e5be",
	"./relics/base/boss.svg": "aa13",
	"./relics/base/common.svg": "6dd6",
	"./relics/base/event.svg": "90032",
	"./relics/base/rare.svg": "2681",
	"./relics/base/shop.svg": "c464",
	"./relics/base/starter.svg": "0ca2",
	"./relics/base/uncommon.svg": "cfc61",
	"./ui/magGlass.svg": "94b7",
	"./ui/plusbg.svg": "70db",
	"./ui/underline.svg": "8d05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52d9";